import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { CanActivateChildGuard } from 'src/app/core/guards/can-activate-child.guard';
import { UpdateAsEnterpriseReviewComponent } from './update-as-enterprise-review/update-as-enterprise.component';


const routes: Routes = [
  {
    path: 'kyc-confirm-account-review/update-enterprise-review',
    component: UpdateAsEnterpriseReviewComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    // canDeactivate: [ConfirmDeactivateGuard],
  },
  {
    path: 'kyc-confirm-account-review/update-enterprise-review-anonymous/:hashKey/:tenantId',
    component: UpdateAsEnterpriseReviewComponent,
    // canDeactivate: [ConfirmDeactivateGuard],
  },
  {
    path: 'kyc-confirm-account-review/update-enterprise-review-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode',
    component: UpdateAsEnterpriseReviewComponent,
    // canDeactivate: [ConfirmDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KycConfirmAccountRoutingModule { }
